import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Image } from "@chakra-ui/react";
import { AuthContext } from "contexts/AuthContext";
import { SettingsDropdown } from "./SettingsDropdown";
import logo from 'images/logo.png';

const Header = ({ loading, isStopped, showResult, onStop, onNewResearch }) => {
    const { logout } = useContext(AuthContext);

    return (
        <div className="h-[60px] px-4 lg:h-[80px] lg:px-0 pt-4 pb-4">
            <div className="flex flex-col items-center">
                <div className="flex justify-between w-full">
                    <div className="w-1/3"></div>
                    <Link to="/" className="w-1/3 flex justify-center">
                        <Image
                            src={logo}
                            alt="logo"
                            className="lg:h-20"
                        />
                    </Link>
                    <div className="w-1/3 flex justify-end">
                        <SettingsDropdown logout={logout}/>
                    </div>
                </div>

                <div className="flex gap-2 mt-6 transition-all duration-300 ease-in-out">
                    {loading && !isStopped && (
                        <button
                            onClick={onStop}
                            className="flex items-center justify-center px-6 h-8 text-sm text-white bg-red-500 rounded-full hover:bg-red-600 transform hover:scale-105 transition-all duration-200 shadow-lg whitespace-nowrap"
                        >
                            Stop
                        </button>
                    )}

                    {(isStopped || !loading) && showResult && (
                        <button
                            style={{backgroundColor: '#6EB5D2'}}
                            onClick={onNewResearch}
                            className="flex items-center justify-center px-6 h-8 text-sm text-white rounded-full transform hover:scale-105 transition-all duration-200 shadow-lg whitespace-nowrap"
                        >
                            New Research
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Header;
